import { MCP_WAITLIST_ENDPOINT, MCP_WAITLIST_TAG } from '../data/mcp'

export class WaitlistNotConfiguredError extends Error {}

export type WaitlistPayload = { email: string; workflow: string; goal: string; sourcePage: string }
export type WaitlistResult = 'saved' | 'already_registered'

export const isWaitlistConfigured = () => MCP_WAITLIST_ENDPOINT.trim().length > 0

/** Saves a waitlist signup. Resolves only once the endpoint confirms it was stored. */
export async function submitMcpWaitlist(payload: WaitlistPayload): Promise<WaitlistResult> {
  if (!isWaitlistConfigured()) throw new WaitlistNotConfiguredError('MCP waitlist endpoint not configured')

  const response = await fetch(MCP_WAITLIST_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ ...payload, tag: MCP_WAITLIST_TAG }),
  })

  if (response.status === 409) return 'already_registered'
  if (!response.ok) throw new Error(`Waitlist request failed (${response.status})`)

  const text = await response.text()
  if (text) {
    try {
      const data = JSON.parse(text) as { status?: string }
      if (data.status === 'already_registered') return 'already_registered'
    } catch {
      // Non-JSON 2xx responses still count as saved.
    }
  }
  return 'saved'
}
